import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './VerifyEmail.module.css';
import { useUser } from '../contexts/UserContext';
import Loader from '../components/Loader';

export default function VerifyEmail() {
  const location = useLocation();
  const { verifyEmail } = useUser();
  const [verified, setVerified] = useState(false);
  const [ failed, setFailed] = useState(false);

  useEffect(() => {
    const verify = async () => {
      const queryParams = new URLSearchParams(location.search);
      const token = queryParams.get('verificationToken');

      if (token) {
        try {
          const {success} = await verifyEmail(token);

          if (success){
            setVerified(true);
          } else {
            setVerified(false);
          }
        } catch (err) {
          setFailed(true);
        }
      }
    }
    verify();
  }, [location.search, verifyEmail]);

  return (
    <div className={styles.container}>
      {verified ? (
        <>
          <img src="/thumbs-up.jpg" alt="Mascot" className={styles.mascot} />
          <h2 className={styles.message}>Thank you for verifying your email!</h2>
          <Link to="/login" className={styles.loginLink}>
            Go to Login
          </Link>
        </>
      ) : (
          failed ? (
            <>
              <h2 className={styles.message}>There was a problem verifying your email</h2>
            </>
          ) : (
            <>
              <h2 className={styles.message}>Verifying your email...</h2>
              <Loader></Loader>
            </>
          )
      )}
    </div>
  );
}
